import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { getPackagingList } from '../../redux/actions/packaging.action';
import { setLoading } from '../../redux/actions/loader.action';
import axios from 'axios';
import { logout } from '../../redux/actions/auth.action';
import { endpointApi } from '../../utils';
import Paginate from '../../components/Paginate';

export default function PackagingPage() {
    const jwt_access = localStorage.getItem('jwt_access');
    const packagingList = useSelector(state => state.packagingList);
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const modalRef = useRef(null);
    const detailsModalRef = useRef(null);
    const operationModalRef = useRef(null);
    const [add, setAdd] = useState(true);
    const [modal, setModal] = useState(null);
    const [packaging, setPackaging] = useState(null);
    const [actionModal, setActionModal] = useState(null);

    const [name, setName] = useState('');
    const [safetyStockLevel, setSafetyStockLevel] = useState('');
    const [quantity, setQuantity] = useState('');
    const [operationDate, setOperationDate] = useState('');
    const [operationType, setOperationType] = useState('');
    const [operationQuantity, setOperationQuantity] = useState('');

    const [isNameTouched, setIsNameTouched] = useState(false);
    const [isSafetyStockLevelTouched, setIsSafetyStockLevelTouched] = useState(false);
    const [isQuantityTouched, setIsQuantityTouched] = useState(false);

    const [isOperationDateTouched, setIsOperationDateTouched] = useState(false);
    const [isOperationTypeTouched, setIsOperationTypeTouched] = useState(false);
    const [isOperationQuantityTouched, setIsOperationQuantityTouched] = useState(false);

    const [errors, setErrors] = useState(null);

    useEffect(() => {
        dispatch(getPackagingList(location, navigate));
    }, [location, dispatch, navigate]);

    useEffect(() => {
        const clickOutsideActionModal = (e) => {
            const $actionModals = document.querySelectorAll('.actions>ul');
            $actionModals.forEach($actionModal => {
                if($actionModal && !$actionModal.contains(e.target) && $actionModal.classList.contains('active')){
                    setActionModal(null);
                }
            });
        }
        document.addEventListener('click', clickOutsideActionModal);
        return () => {
            document.removeEventListener('click', clickOutsideActionModal);
        }
    }, []);

    const _close = useCallback(() => {
        setModal(null);
        setName("");
        setSafetyStockLevel("");
        setQuantity("");
        setOperationDate("");
        setOperationType("");
        setOperationQuantity("");

        setIsNameTouched(false);
        setIsSafetyStockLevelTouched(false);
        setIsQuantityTouched(false);
        setIsOperationDateTouched(false);
        setIsOperationTypeTouched(false);
        setIsOperationQuantityTouched(false);

        dispatch(setLoading(false));
        setErrors(null);
    
        setTimeout(() => {
          setAdd(true);
          setPackaging(null);
        }, 200);
    }, [dispatch]);

    const close = useCallback((e) => {
        if(modalRef.current === e.target || detailsModalRef.current === e.target || operationModalRef.current === e.target || e.target.classList.contains('_modal-close')){
          _close();
        }
    }, [_close]);

    useEffect(() => {
        document.addEventListener('click', close);
        return () => {
            document.removeEventListener('click', close);
        }
    }, [close]);

    useEffect(() => {
        if(packaging){
            setName(packaging.name ? packaging.name : "");
            setSafetyStockLevel(packaging.safety_stock_level ? packaging.safety_stock_level : "");
            setQuantity(packaging.quantity ? packaging.quantity : "");
            setAdd(false);
        }
    }, [packaging]);

    useEffect(() => {
        if(modal){
            const $modals = document.querySelectorAll('._modal-content');
            $modals.forEach($modal => {
                $modal.scrollTop = 0;
            })
        }
    }, [modal]);

    const handleSubmit = async(e) => {
        e.preventDefault();
        dispatch(setLoading(true));
        setErrors(null);
        const data = new FormData(e.target);
        if(add){
            await axios.post(`${ endpointApi }packagings`, data, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${ jwt_access }`
                }
            }).then(({ data }) => {
                dispatch(getPackagingList(location, navigate));
                setPackaging(data);
                setModal("details");
            }).catch(err => {
                if(err.response.status === 401){
                    dispatch(logout(location.pathname + location.search, navigate));
                }else{
                    setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                    const $modals = document.querySelectorAll('._modal-content');
                    $modals.forEach($modal => {
                        $modal.scrollTop = 0;
                    });
                }
            })
            .finally(() => {
                dispatch(setLoading(false));
            });
        }else{
            await axios.put(`${ endpointApi }packagings/${ packaging?.id }`, data, {
                headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${ jwt_access }`
                }
            }).then(({ data }) => {
                dispatch(getPackagingList(location, navigate));
                setPackaging(data);
                setModal("details");
            }).catch(err => {
                if(err.response.status === 401){
                    dispatch(logout(location.pathname + location.search, navigate));
                }else{
                    setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                    const $modals = document.querySelectorAll('._modal-content');
                    $modals.forEach($modal => {
                        $modal.scrollTop = 0;
                    });
                }
            })
            .finally(() => {
                dispatch(setLoading(false));
            });
        }
    }

    const handleSubmit2 = async(e) => {
        e.preventDefault();
        dispatch(setLoading(true));
        setErrors(null);
        const data = new FormData(e.target);

        await axios.post(`${ endpointApi }packagings/${ packaging?.id }/operation`, data, {
            headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${ jwt_access }`
            }
        }).then(({ data }) => {
            dispatch(getPackagingList(location, navigate));
            setPackaging(data);
            setModal("details");
        }).catch(err => {
            if(err.response.status === 401){
                dispatch(logout(location.pathname + location.search, navigate));
            }else{
                setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                const $modals = document.querySelectorAll('._modal-content');
                $modals.forEach($modal => {
                    $modal.scrollTop = 0;
                });
            }
        })
        .finally(() => {
            dispatch(setLoading(false));
        });
    }

    return (
        <HelmetProvider>
            <Helmet>
                <title>Packagings - Société Mikalo</title>
            </Helmet>

            <div className='title d-flex justify-content-between'>
                <h1>Packagings</h1>
                <button type='button' onClick={ () => {
                    setAdd(true);
                    setModal('add');
                } } className='btn btn-primary'><i className='fa fa-plus'></i> Ajouter</button>
            </div>

            <div ref={ modalRef } className={ `_modal${ modal === 'add' || (packaging && modal === 'update') ? ' active' : '' }` }>
                <div className='_modal-content'>
                    <div className='_modal-head'>
                        <h4>{ add ? 'Ajouter' : 'Modifier' } un packaging</h4>
                        <button className='_modal-close'>&times;</button>
                    </div>
                    <div className='_modal-body'>
                        <form className='form' onSubmit={ handleSubmit }>
                            { errors && errors.error && <div className='alert alert-danger'>{ errors.error }</div> }
                            <div className='pb-3'>
                                <label htmlFor='name' className='required'>Nom du packaging</label>
                                <input type='text' id='name' name='name' placeholder="Nom du packaging" autoComplete='off' className='form-control' required value={ name } onChange={ (e) => setName(e.target.value) } onBlur={ () => setIsNameTouched(true) } />
                                { isNameTouched && name.length === 0 && <div className='form-error'>Veuillez saisir le nom du packaging.</div> }
                                { isNameTouched && name.length > 0 && name.length < 2 && <div className='form-error'>Le nom du packaging est trop court. Veuillez saisir au moins 2 caractères.</div> }
                                { errors && errors.name && <div className='form-error'>{ errors.name[0] }</div> }
                            </div>
                            
                            <div className='pb-3'>
                                <label htmlFor='safety_stock_level' className='required'>Stock de sécurité</label>
                                <input type='number' min="0" step="1" id='safety_stock_level' name='safety_stock_level' placeholder="Stock de sécurité" autoComplete='off' className='form-control' required value={ safetyStockLevel } onChange={ (e) => setSafetyStockLevel(e.target.value) } onBlur={ () => setIsSafetyStockLevelTouched(true) } />
                                { isSafetyStockLevelTouched && safetyStockLevel.length === 0 && <div className='form-error'>Veuillez saisir le stock de sécurité.</div> }
                                { errors && errors.safety_stock_level && <div className='form-error'>{ errors.safety_stock_level[0] }</div> }
                            </div>
                            
                            <div className='pb-3'>
                                <label htmlFor='quantity' className='required'>Quantité</label>
                                <input type='number' min="0" step="1" id='quantity' name='quantity' placeholder="Quantité" autoComplete='off' className='form-control' required value={ quantity } onChange={ (e) => setQuantity(e.target.value) } onBlur={ () => setIsQuantityTouched(true) } />
                                { isQuantityTouched && safetyStockLevel.length === 0 && <div className='form-error'>Veuillez saisir la quantité.</div> }
                                { errors && errors.quantity && <div className='form-error'>{ errors.quantity[0] }</div> }
                            </div>

                            <div className='pt-2 text-end'>
                                <button type='submit' className='btn btn-lg btn-primary' disabled= {
                                name.length < 0 || safetyStockLevel.length === 0 || quantity.length === 0
                                || (packaging && add === false && name === packaging.name && safetyStockLevel === packaging.safety_stock_level && quantity === packaging.quantity)
                                }>{ add ? <><i className="fa fa-save"></i> Enregistrer</> : <><i className="fa fa-save"></i> Mettre à jour</> }</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div ref={ detailsModalRef } className={ `_modal${ (modal === 'details' && packaging) ? ' active' : '' }` }>
                <div className='_modal-content'>
                { packaging && <>
                    <div className='_modal-head'>
                        { packaging &&
                        <h4>{ packaging.code + " - " + packaging.name }</h4> }
                        <button className='_modal-close'>&times;</button>
                    </div>
                    <div className='_modal-body'>
                    { packaging && <>
                        <div className='mb-3'>
                            <div className='_label'>Code</div>
                            <div className='_value'>{ packaging.code }</div>
                        </div>
                        <div className='mb-3'>
                            <div className='_label'>Nom de packaging</div>
                            <div className='_value'>{ packaging.name }</div>
                        </div>
                        <div className='row'>
                            <div className='col-6 mb-3'>
                                <div className='_label'>Quantité</div>
                                <div className='_value'>{ packaging.quantity }{ packaging.unit ? ' ' + (packaging.unit === 'Item' ? 'pièce' : (packaging.unit === 'Box' ? 'boîte' : 'carton')) + (packaging.quantity > 1 ? 's' : ''): "" }</div>
                            </div>
                            <div className='col-6 mb-3'>
                                <div className='_label'>Stock de sécurité</div>
                                <div className='_value'>{ packaging.safety_stock_level }{ packaging.unit ? ' ' + (packaging.unit === 'Item' ? 'pièce' : (packaging.unit === 'Box' ? 'boîte' : 'carton')) + (packaging.quantity > 1 ? 's' : ''): "" }</div>
                            </div>
                        </div>
                        <div className='mb-3'>
                            <div className='_label'>Etat</div>
                            <div className='_value'>{ packaging.safety_stock_level > 0 ? (packaging.quantity <= packaging.safety_stock_level ? <span className='badge bg-danger'>En rupture de stock</span> : <span className='badge bg-success'>En stock</span>) : '-' }</div>
                        </div>
                        <div className='pt-2 text-center'>
                            <button type='button' className='btn btn-lg btn-primary me-3' onClick={ () => {
                                setModal("operation")
                            } }><i className='fa fa-plus-minus'></i> Faire une opération</button>
                            <button type='button' className='btn btn-lg btn-primary' onClick={ () => {
                                setModal("update")
                            } }><i className='fa fa-edit'></i> Modifier</button>
                        </div>
                    </> }
                    </div>
                </> }
                </div>
            </div>

            <div ref={ operationModalRef } className={ `_modal${ modal === 'operation' && packaging ? ' active' : '' }` }>
                <div className='_modal-content'>
                    <div className='_modal-head'>
                        <h4>Entrée ou sortie packaging</h4>
                        <button className='_modal-close'>&times;</button>
                    </div>
                    <div className='_modal-body'>
                        <form className='form' onSubmit={ handleSubmit2 }>
                            { errors && errors.error && <div className='alert alert-danger'>{ errors.error }</div> }
                            { packaging && 
                            <div className='mb-3'>
                                <table className='table table-striped'>
                                    <tbody>
                                        <tr>
                                            <td width="160px">Code</td>
                                            <td>{ packaging.code }</td>
                                        </tr>
                                        <tr>
                                            <td width="160px">Nom de packaging</td>
                                            <td>{ packaging?.name }</td>
                                        </tr>
                                        <tr>
                                            <td width="160px">Quantité</td>
                                            <td>{ packaging?.quantity }</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div> }
                            { errors && errors.error && <div className='alert alert-danger'>{ errors.error }</div> }
                            <div className='mb-3'>
                                <label htmlFor='operationDate' className='required'>Date de l'opération</label>
                                <input type="date" id="operationDate" name="operation_date" className='form-control' placeholder="Date de l'opération" required value={ operationDate } onChange={ (e) => setOperationDate(e.target.value) } onBlur={ () => setIsOperationDateTouched(true) } />
                                { isOperationDateTouched && operationDate.length === 0 && <div className='form-error'>Veuillez sélectionner la date de l'opération.</div> }
                                { errors && errors.operation_date && <div className='form-error'>{ errors.operation_date[0] }</div> }
                            </div>
                            <div className='row'>
                                <div className='col-6 mb-3'>
                                    <label htmlFor='operationType' className='required'>Type d'opération</label>
                                    <select id="operationType" name="operation_type" className='form-control' required value={ operationType } onChange={ (e) => setOperationType(e.target.value) } onBlur={ () => setIsOperationTypeTouched(true) }>
                                        <option value="">Sélectionner</option>
                                        <option value="IN">Entrée</option>
                                        <option value="OUT">Sortie</option>
                                    </select>
                                    { isOperationTypeTouched && operationType.length === 0 && <div className='form-error'>Veuillez sélectionner le type d'opération.</div> }
                                    { errors && errors.operation_type && <div className='form-error'>{ errors.operation_type[0] }</div> }
                                </div>
                                <div className='col-6 mb-3'>
                                    <label htmlFor='operationQuantity' className='required'>Quantité</label>
                                    <input type="number" min={ 1 } step={ 1 } max={ packaging && operationType === 'out' ? packaging.quantity : 1000 } id="operationQuantity" name="operation_quantity" className='form-control' placeholder='Quantité' required value={ operationQuantity } onChange={ (e) => setOperationQuantity(e.target.value) } onBlur={ () => setIsOperationQuantityTouched(true) } />
                                    { isOperationQuantityTouched && operationQuantity.length === 0 && <div className='form-error'>Veuillez sélectionner la quantité.</div> }
                                    { errors && errors.operation_quantity && <div className='form-error'>{ errors.operation_quantity[0] }</div> }
                                </div>
                            </div>
                            <div className='pt-2 text-end'>
                                <button type='submit' className='btn btn-lg btn-primary' disabled={
                                    operationType.length === 0 || operationQuantity.length === 0
                                }>Effectuer cette opération</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div className='box'>
                <table className='table table-striped'>
                    <thead>
                        <tr>
                            <th width="100">Code</th>
                            <th>Nom du packaging</th>
                            <th className='text-center'>Stock de sécurité</th>
                            <th className="text-center">Quantité</th>
                            <th>Etat</th>
                            <th className="text-end">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        { packagingList.loading && <tr><td colSpan={ 6 }>Chargement...</td></tr> }
                        { packagingList.loading === false && packagingList.data && packagingList.data.total === 0 && <tr><td colSpan={ 6 }>Aucun élément trouvé</td></tr> }
                        { packagingList.loading === false && packagingList.data && packagingList.data.data && packagingList.data.data.map((item, index) => {
                        return (
                        <tr key={ index }>
                            <td>{ item.code }</td>
                            <td>{ item.name }</td>
                            <td className='text-center'>{ item.safety_stock_level }</td>
                            <td className="text-center">{ item.quantity }{ item.unit ? ' ' + (item.unit === 'Item' ? 'pièce' : (item.unit === 'Box' ? 'boîte' : 'carton')) + (item.quantity > 1 ? 's' : '') : '' }</td>
                            <td>{ item.safety_stock_level > 0 ? (item.quantity <= item.safety_stock_level ? <span className='badge bg-danger'>En rupture de stock</span> : <span className='badge bg-success'>En stock</span>) : "-" }</td>
                            <td className="text-end">
                                <div className='actions'>
                                    <button type='button' className='toggle-action' onClick={ (e) => {
                                        e.stopPropagation();
                                        setActionModal(actionModal !== item.id ? item.id : null);
                                    } }><i className='fa fa-ellipsis-v'></i></button>
                                    <ul className={ actionModal === item.id ? 'active' : '' }>
                                        <li><button type='button' onClick={ () => {
                                            setActionModal(null);
                                            setPackaging(item);
                                            setModal("details")
                                        } }><i className="fa fa-eye"></i> Voir les détails</button></li>
                                        <li><button type='button' onClick={ () => {
                                            setActionModal(null);
                                            setPackaging(item);
                                            setModal("operation")
                                        } }><i className="fa fa-plus-minus"></i> Faire une opération</button></li>
                                        <li><button type='button' onClick={ () => {
                                            setActionModal(null);
                                            setPackaging(item);
                                            setModal("update")
                                        } }><i className="fa fa-edit"></i> Modifier</button></li>
                                    </ul>
                                </div>
                            </td>
                        </tr> ) })}
                    </tbody>
                </table>
            </div>
            
            { packagingList && packagingList.data &&
            <Paginate currentPage={ packagingList.data.current_page } totalPages={ packagingList.data.last_page } pathname={ location.pathname } search={ location.search } /> }
        </HelmetProvider>
    )
}
